var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMala(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.02,
    height: 31,
    viewBox: "0 0 35.02 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-mala",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "briefcase",
    d: "M34.02,38.522a2.993,2.993,0,0,0-2.99-2.99H25.714V33.388a3.141,3.141,0,0,0-3.138-3.138H11.443a3.141,3.141,0,0,0-3.138,3.138v2.145H2.99A2.993,2.993,0,0,0,0,38.522V43.24a4.3,4.3,0,0,0,1.329,3.051V57.26a2.993,2.993,0,0,0,2.99,2.99H29.7a2.993,2.993,0,0,0,2.99-2.99V46.291A4.3,4.3,0,0,0,34.02,43.24ZM10.3,33.388a1.146,1.146,0,0,1,1.144-1.144H22.577a1.146,1.146,0,0,1,1.144,1.144v2.145H10.3ZM1.993,38.522a1,1,0,0,1,1-1H31.03a1,1,0,0,1,1,1V43.24c0,2.452-4.7,4.454-11.561,4.978v-.925a1,1,0,0,0-1-1H14.552a1,1,0,0,0-1,1v.924C6.7,47.692,1.993,45.686,1.993,43.24ZM18.472,48.29v1.3a1.3,1.3,0,0,1-1.3,1.3h-.332a1.3,1.3,0,0,1-1.3-1.3v-1.3ZM29.7,58.257H4.319a1,1,0,0,1-1-1V47.753c2.968,1.521,6.087,2.107,10.295,2.468a3.294,3.294,0,0,0,3.227,2.654h.332A3.294,3.294,0,0,0,20.4,50.221,30.6,30.6,0,0,0,29.309,48.4a13.565,13.565,0,0,0,1.389-.651V57.26A1,1,0,0,1,29.7,58.257Z",
    transform: "translate(0 -30.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMala);
export default __webpack_public_path__ + "static/media/ico-mala.83dfcc869c261318b0989a7bc9b83e78.svg";
export { ForwardRef as ReactComponent };